import Settings from 'components/Settings'
import PasswordManagement from 'components/PasswordManagement'
import Import from 'components/ImportModal'
import Export from 'components/ExportModal'
import Search from 'components/SearchModal'
import DebugMsgModal from 'components/ErrorsHandler/DebugMsgModal'
import ModalFilterList from 'components/Filterbar/ModalFilterList'
import ModalSaveFilter from 'components/Filterbar/ModalSaveFilter'
import ModalScenarioReset from 'pages/Scenario/Manager/components/ModalScenarioReset'
import {
  ModalDeletionError,
  ModalConfirmAction,
  ModalSaveDocument,
  ModalImportError
} from 'pages/InputView/modals'
import ModalUploadError from 'pages/Scenario/Manager/components/modals/UploadError'
import ModelInfo from 'pages/InputView/modals/ModelInfo'
import Wizard from 'components/Wizard'
import LockColumsModal from 'components/LockColumnsModal'
import ModalChangelog from 'components/Settings/components/modal'
import BuilderExpression from 'components/BuilderExpression'
import DeletingScenarioModal from 'pages/Scenario/Manager/components/DeletingScenarioModal'
import EnablingScenarioModal from 'components/EnablingScheduledScenarioModal'
import ConfirmChangesModal from 'components/ConfirmChangesModal'
import RoleModal from 'pages/Administration/components/Modals/RoleModal'
import UserModal from 'pages/Administration/components/Modals/UserModal'
import OutputModal from 'pages/Administration/components/Modals/OutputModal'
import InstanceCloningModal from 'pages/Administration/components/Modals/InstanceCloningModal'
import InstanceModal from 'pages/Administration/components/Modals/InstanceModal'
import ScenarioModal from 'pages/Administration/components/Modals/ScenarioModal'

import TableGetInfoFilterModal from '@ublique/components/ColumnsFilterButtonTable/TableGetInfoFilterModal'
import TableSaveFilterModal from '@ublique/components/ColumnsFilterButtonTable/TableSaveFilterModal'
import CreateNewInstanceModal from 'components/CreateNewInstanceModal'
import SimulateScenarioModal from 'pages/Scenario/Scheduled/modals/simulateScenarioModal'
import PurgerModal from 'pages/Scenario/Purger/modals/PurgerModal'
import CancelingScenarioModal from 'pages/Scenario/Manager/components/CancelingScenarioModal'
import WarningScenarioModal from 'pages/Scenario/Manager/components/WarningScenarioModal'
import KillingScenarioModal from 'pages/Scenario/Manager/components/KillingScenarioModal'
import ProgressScenarioModal from 'pages/Scenario/Manager/components/ProgressScenarioModal'

export const isDevMode = process.env.NODE_ENV === 'development'

export const defaultThemes = [
  {
    id: 'light',
    label: 'Light'
  },
  {
    id: 'dark',
    label: 'Dark'
  }
]

export const EXTRA_OUTPUT = 'extraOutput'

export const UBLIQUE = 'Ublique'

export const platformModals = {
  settings: Settings,
  password: PasswordManagement,
  import: Import,
  export: Export,
  search: Search,
  saveDocument: ModalSaveDocument,
  confirmAction: ModalConfirmAction,
  documentDeletionErrors: ModalDeletionError,
  scenarioReset: ModalScenarioReset,
  modelInfo: ModelInfo,
  debugMessage: DebugMsgModal,
  filterList: ModalFilterList,
  filterSave: ModalSaveFilter,
  wizard: Wizard,
  changelog: ModalChangelog,
  builderExpression: BuilderExpression,
  lockColumnsModal: LockColumsModal,
  deletingScenario: DeletingScenarioModal,
  cancelingScenario: CancelingScenarioModal,
  killingScenario: KillingScenarioModal,
  warningScenario: WarningScenarioModal,
  progressScenario: ProgressScenarioModal,
  enablingScenario: EnablingScenarioModal,
  importError: ModalImportError,
  uploadError: ModalUploadError,
  confirmEditedSave: ConfirmChangesModal,
  administrationRole: RoleModal,
  administrationUser: UserModal,
  administrationOutput: OutputModal,
  administrationInstanceClone: InstanceCloningModal,
  administrationInstance: InstanceModal,
  administrationScenario: ScenarioModal,
  myFiltersInfo: TableGetInfoFilterModal,
  saveMyFilters: TableSaveFilterModal,
  createNewInstance: CreateNewInstanceModal,
  simulateScenario: SimulateScenarioModal,
  purger: PurgerModal
}
